import { FormGroup } from '@angular/forms';
import { createAction, props } from '@ngrx/store';
import { app_perm_set_line_RowClass } from 'blg-akaun-ts-lib';
import { RoleDetailsForm, RoleForm, RoleModel } from '../../../../models/role-permissions.model';

export const loadRolesInit = createAction('[Roles] Load Roles Init', props<{ request: any }>());
export const loadRolesSuccess = createAction('[Roles] Load Roles Success', props<{ totalRecords: number }>());
export const loadRolesFailure = createAction('[Roles] Load Roles Failure', props<{ error: string }>());

// create new role
export const createRoleInit = createAction('[Roles] Create Role Init', props<{ role: RoleForm }>());
export const createRoleSuccess = createAction('[Roles] Create Role Success');
export const createRoleFailure = createAction('[Roles] Create Role Failure', props<{error: string}>());

// update role details
export const updateRoleInit = createAction('[Roles] Update Role Init', props<{guid: string, role: RoleDetailsForm}>());
export const updateRoleSuccess = createAction('[Roles] Update Role Success');
export const updateRoleFailure = createAction('[Roles] Update Role Failure', props<{error: string}>());

// delete role
export const deleteRoleWithPermsInit = createAction('[Roles] Delete Role With Perms Init', props<{permAssigneeGuids: string[]}>());
export const deleteRoleWithPermsSuccess = createAction('[Roles] Delete Role With Perms Success');
export const deleteRoleWithPermsFailure = createAction('[Roles] Delete Roles With Perms Failure', props<{error: string}>());

export const deleteRoleInit = createAction('[Roles] Delete Role Init', props<{guid: string}>());
export const deleteRoleSuccess = createAction('[Roles] Delete Role Success');
export const deleteRoleFailure = createAction('[Roles] Delete Role Failure', props<{error: string}>());

// add users to role
export const addUsersToRoleInit = createAction('[Roles] Add Users to Role Init', props<{subjectGuids: string[], roleGuid: string}>());
export const addUsersToRoleSucess = createAction('[Roles] Add Users to Role Success');
export const addUsersToRoleFailure = createAction('[Roles] Add Users to Role Failure', props<{error: string}>());

// remove users from role
export const removeUsersFromRoleInit = createAction('[Roles] Remove Users from Role Init', props<{guids: string[]}>());
export const removeUsersFromRoleSuccess = createAction('[Roles] Remove Users from Role Success');
export const removeUsersFromRoleFailure = createAction('[Roles] Remove Users from Role Failure', props<{error: string}>());

// add teams to role
export const addTeamsToRoleInit = createAction('[Roles] Add Teams to Role Init', props<{teamGuids: string[], roleGuid: string}>());
export const addTeamsToRoleSuccess = createAction('[Roles] Add Teams to Role Success');
export const addTeamsToRoleFailure = createAction('[Roles] Add Teams to Role Failure', props<{error: string}>());

// remove teams from role
export const removeTeamsFromRoleInit = createAction('[Roles] Remove Teams from Role Init', props<{guids: string[]}>());
export const removeTeamsFromRoleSuccess = createAction('[Roles] Remove Teams from Role Success');
export const removeTeamsFromRoleFailure = createAction('[Roles] Remove Teams from Role Failure', props<{error: string}>());

// add permission set to role
export const addPermSetsToRoleInit = createAction('[Roles] Add Permission Sets to Role Init', props<{permSetLines: app_perm_set_line_RowClass[], appletGuid: string, roleGuid: string}>());
export const addPermSetsToRoleSuccess = createAction('[Roles] Add Permission Sets to Role Success');
export const addPermSetsToRoleFailure = createAction('[Roles] Add Permission Sets to Role Failure', props<{error: string}>());

// remove permission sets from role
export const removePermSetsFromRoleInit = createAction('[Roles] Remove Permission Sets from Role Init', props<{guids: string[]}>());
export const removePermSetsFromRoleSuccess = createAction('[Roles] Remove Permission Sets from Role Success');
export const removePermSetsFromRoleFailure = createAction('[Roles] Remove Permission Sets from Role Failure', props<{error: string}>());

// add client side permissions to role
export const addClientSidePermsToRoleInit = createAction('[Roles] Add Client Side Permissions to Role Init', props<{clientGuids: string[], appletGuid: string, roleGuid: string}>());
export const addClientSidePermsToRoleSuccess = createAction('[Roles] Add Client Side Permissions to Role Success');
export const addClientSidePermsToRoleFailure = createAction('[Roles] Add Client Side Permissions to Role Failure', props<{error: string}>());

// remove client side permissions from role
export const removeClientSidePermsFromRoleInit = createAction('[Roles] Remove Client Side Permissions to Role Init', props<{guids: string[]}>());
export const removeClientSidePermsFromRoleSuccess = createAction('[Roles] Remove Client Side Permissions to Role Success');
export const removeClientSidePermsFromRoleFailure = createAction('[Roles] Remove Client Side Permissions to Role Failure', props<{error: string}>());

export const selectEntity = createAction('[Roles] Select Entity', props<{ entity: RoleModel }>());
export const selectGuid = createAction('[Roles] Select Guid', props<{ guid: string }>());

// set
export const setDetailsForm = createAction('[Roles] Set Details Form', props<{form: RoleDetailsForm}>());

export const setUpdateRoleListing = createAction('[Roles] Set Update Role Listing', props<{update: boolean}>());
export const setUpdateUserRoleListing = createAction('[Roles] Set Update User Role Listing', props<{update: boolean}>());
export const setUpdateTeamRoleListing = createAction('[Roles] Set Update Team Role Listing', props<{update: boolean}>());
export const setUpdateAllPermSetListing = createAction('[Roles] Set Update All Perm Set Listing', props<{update: boolean}>());
export const setUpdateAllClientSideListing = createAction('[Roles] Set Update Client Side Listing', props<{update: boolean}>());

// add permission set hdr to role
export const addPermSetHdrToRoleInit = createAction('[Roles] Add Permission Set Hdr to Role Init', props<{permSetHdrGuids: any[], appletGuid: string, roleGuid: string, prevIndex: any, prevLocalState:any}>());
export const addPermSetHdrToRoleSuccess = createAction('[Roles] Add Permission Set Hdr to Role Success');
export const addPermSetHdrToRoleFailure = createAction('[Roles] Add Permission Set Hdr to Role Failure', props<{error: string}>());
